import React, {Fragment} from "react"
import DisplayAge from "../components/DisplayAge"

const DisplayDate = function({date}) {
    var utcDate = new Date(date + "Z")
    var seconds = Math.floor((Date.now() - utcDate.getTime()) / 1000)
    return ( <Fragment>{utcDate.toLocaleString()} (<DisplayAge seconds={seconds}/>  ago)</Fragment> )
}

export default DisplayDate